import { determineResultType } from './quizScoring';

// Simulated Supabase integration
export async function saveBusinessQuizLead(formData, quizAnswers) {
  return new Promise((resolve) => {
    const resultType = determineResultType(quizAnswers);
    
    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      address_zip: formData.zipCode,
      business_name: formData.businessName,
      source: 'business_quiz',
      status: 'lead',
      quiz_result_type: resultType,
      created_at: new Date().toISOString()
    };

    console.log('✅ [Supabase Mock] Lead Captured:', payload);
    console.log('✅ [Supabase Mock] Answers:', quizAnswers);
    
    setTimeout(() => {
      resolve({ success: true, resultType });
    }, 1500);
  });
}